// extracted by mini-css-extract-plugin
export default {"cls1":"TruncateHeight-cls1_o__","cls2":"TruncateHeight-cls2_P6j TruncateHeight-cls1_o__"};